var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyStars1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Highlight 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 263",
    d: "M69.8335 36.2334C70.8289 40.8191 75.8558 49.9906 88 49.9906",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 265",
    d: "M69.8333 68.5095C69.1278 63.9826 65.5651 54.9287 56.958 54.9287",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 264",
    d: "M69.8333 36.0566C69.1278 42.3473 65.5651 54.9286 56.958 54.9286",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 266",
    d: "M69.8335 68.5095C70.8289 62.3364 75.8558 49.9903 88 49.9903",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Highlight 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 263_2",
    d: "M36.7049 3.19824C38.5706 8.48439 47.9924 19.0567 70.7539 19.0567",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 265_2",
    d: "M36.7053 88.5518C34.8396 70.5167 25.4178 34.4465 2.65625 34.4465",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 264_2",
    d: "M36.7053 2.73047C34.8396 13.3028 25.4178 34.4474 2.65625 34.4474",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 266_2",
    d: "M36.7049 88.5518C38.5706 65.386 47.9924 19.0544 70.7539 19.0544",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyStars1);
export default __webpack_public_path__ + "static/media/party-stars1.c463c71bb860ca910aca983ce6591c16.svg";
export { ForwardRef as ReactComponent };